// The MIT License (MIT)
//
// Copyright (c) 2015-2020 Camptocamp SA
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

/**
 * Application entry point.
 *
 * This file includes `import`'s for all the components/directives used
 * by the HTML page and the controller to provide the configuration.
 */

import './sass/vars_mobile.scss';
import './sass/mobile.scss';

import angular from 'angular';
import gmfControllersAbstractMobileController, {
  AbstractMobileController,
} from 'gmf/controllers/AbstractMobileController';
import lausanne_mapfishBase from '../lausanne_mapfishmodule';

/**
 * @private
 */
class Controller extends AbstractMobileController {
  /** Ajout bouton Dark Mode */
  dark_mode() {
    const lightpath = this.ngeoLocation.getPath();
    let darkpath = '';
    if (lightpath.includes('mobile.html')) {
      darkpath = lightpath.replace('mobile.html', 'mobile_dark.html');
    } else {
      darkpath = 'mobile_dark';
    }
    this.ngeoLocation.setPath(darkpath);
    const baselayername = 'fonds_geo_osm_bdcad_dark';
    this.ngeoLocation.updateParams({
      'baselayer_ref': baselayername,
    });
    window.location.href = this.ngeoLocation.getUriString();
  }
}

/**
 * @hidden
 */
const lausanne_mapfishModule = angular.module('Appmobile', [
  lausanne_mapfishBase.name,
  gmfControllersAbstractMobileController.name,
]);

lausanne_mapfishModule.controller('MobileController', Controller);

export default lausanne_mapfishModule;
